/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetricValueJsonAggregatedValuesDto
 */
export interface MetricValueJsonAggregatedValuesDto {
    /**
     * Sum of JSON values (sums numeric values within JSON objects)
     * @type {object}
     * @memberof MetricValueJsonAggregatedValuesDto
     */
    sum?: object;
    /**
     * Minimum JSON values (min of numeric values within JSON objects)
     * @type {object}
     * @memberof MetricValueJsonAggregatedValuesDto
     */
    min?: object;
    /**
     * Maximum JSON values (max of numeric values within JSON objects)
     * @type {object}
     * @memberof MetricValueJsonAggregatedValuesDto
     */
    max?: object;
    /**
     * Latest JSON value recorded
     * @type {object}
     * @memberof MetricValueJsonAggregatedValuesDto
     */
    latest?: object;
}

/**
 * Check if a given object implements the MetricValueJsonAggregatedValuesDto interface.
 */
export function instanceOfMetricValueJsonAggregatedValuesDto(value: object): value is MetricValueJsonAggregatedValuesDto {
    return true;
}

export function MetricValueJsonAggregatedValuesDtoFromJSON(json: any): MetricValueJsonAggregatedValuesDto {
    return MetricValueJsonAggregatedValuesDtoFromJSONTyped(json, false);
}

export function MetricValueJsonAggregatedValuesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricValueJsonAggregatedValuesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sum': json['sum'] == null ? undefined : json['sum'],
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
        'latest': json['latest'] == null ? undefined : json['latest'],
    };
}

export function MetricValueJsonAggregatedValuesDtoToJSON(json: any): MetricValueJsonAggregatedValuesDto {
    return MetricValueJsonAggregatedValuesDtoToJSONTyped(json, false);
}

export function MetricValueJsonAggregatedValuesDtoToJSONTyped(value?: MetricValueJsonAggregatedValuesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sum': value['sum'],
        'min': value['min'],
        'max': value['max'],
        'latest': value['latest'],
    };
}

